import { useEffect } from 'react';
import { PRINT_PACKING_SLIP_PEEL_HTML_CLASS } from './thermalPrintConstants';
import { usePackingSlipThermalPageStyle } from './usePackingSlipThermalPageStyle';

/**
 * Thermal @page (4in × 6.75in) injection + html class for printPackingSlipPeel.scss.
 * Use on packing-slip and shipping-label print routes.
 */
export function useThermalPrintViewSetup(): void {
    usePackingSlipThermalPageStyle();

    useEffect(() => {
        document.documentElement.classList.add(PRINT_PACKING_SLIP_PEEL_HTML_CLASS);
        return () => {
            document.documentElement.classList.remove(PRINT_PACKING_SLIP_PEEL_HTML_CLASS);
        };
    }, []);
}
